
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_14an4_tn651_5",
  "body": "awsui_body_14an4_tn651_9",
  "description": "awsui_description_14an4_tn651_13",
  "header": "awsui_header_14an4_tn651_17",
  "footer": "awsui_footer_14an4_tn651_21"
};
  